import { ContactModelV2 } from 'Models/ContactModelV2';
import { StateCreator } from 'zustand';
import {
  ConversationMentionsSlice,
  ConversationMentionsSliceState,
} from './index.types';

const initialState: ConversationMentionsSliceState = {
  mentionUsers: new Map<string, ContactModelV2>(),
};

export const createConversationMentionsSlice: StateCreator<
  ConversationMentionsSlice
> = (set, get) => ({
  ...initialState,
  addMentionUser: (mentionUser) => {
    const mentionUsersAux = new Map(get().mentionUsers);

    mentionUsersAux.set(mentionUser.sourceId, mentionUser);

    set({ mentionUsers: mentionUsersAux });
  },
});
